export default "__VITE_ASSET__CG$tRYxS__"